module.exports = __webpack_public_path__ + "static/pinkteddyjacket-774731934d6761bd426acaeca0b2748a.jpeg";